import { createAction, props } from '@ngrx/store';

export const writeTrackingPayloadToState = createAction(
  '[Basket Tracking Payloads] Write Tracking Payload To State',
  props<{ eventName: string; payload?: {} }>(),
);

export const resetTrackingPayloadToState = createAction(
  '[Basket Tracking Payloads] Reset Tracking Payload To State',
);
